import { useHistory } from 'react-router-dom';

function BrandCard(props) {
  const history = useHistory();
  const { langs, prod, image, logo } = props;

  const goBrandPage = (catename, cateID) => {
    history.push(`/machineUI/category/brand/${catename}/${cateID}`);
  };

  return (
    <div
      className="brand-logo-card d-flex justify-content-center align-items-center"
      onClick={() => {
        localStorage.setItem('currentCate', JSON.stringify(prod));
        goBrandPage(prod.name[langs], prod._id);
      }}
    >
      <img className="brand-logo-img" src={logo} alt=""></img>
      {/* <div className="card-title">{prod.name[langs]}</div> */}
    </div>
  );
}
export default BrandCard;
